const basicPath = 'https://upload.9fzt.com/production/jfzt-website-wap/assets';

const pathMap = {
    comHeaderLogo: '/common/header-logo.png',
    comHeaderDefaultAvatar: '/common/default-avatar.png',
    comHeaderDropMenuIconExpend: '/common/drop-menu-icon-expend.png',
    comHeaderDropMenuIconClose: '/common/drop-menu-icon-close.png',
    headlineIcon: '/common/headline-icon.png',
    rankTop1: '/common/rank-top-1.png',
    rankTop2: '/common/rank-top-2.png',
    rankTop3: '/common/rank-top-3.png',
    homePageLogo: '/homePage/logo.png',
    newsListPlayBtn: '/newsList/play.png',
    pauseBtn: '/newsList/pause.png',
    videoPlayIcon: '/video/playIcon.png',
    videoTimeIcon: '/video/timeIcon.png',
    fullscreen: '/video/fullscreen.png',
    volume: '/video/volume.png',
    volumeMute: '/video/volumeMute.png',
    videoLoading: '/video/loading.png',
    search: '/homePage/search.png',
    homePageIconSearch: '/homePage/icon-search.png',
    homePageIconZX: '/homePage/icon-zx.png',
    homePageIconGP: '/homePage/icon-gp.png',
    homePageIconJJ: '/homePage/icon-jj.png',
    homePageIconBK: '/homePage/icon-bk.png',
    homePageIconQQ: '/homePage/icon-qq.png',
    homePageIconGG: '/homePage/icon-gg.png',
    homePageIconScrollTop: '/homePage/icon-scrollTop.png',
    homePageNavBg: '/homePage/nav-bg.png',
    loginBack: '/login/back.png',
    loginIconPhone: '/login/icon-phone.png',
    loginIconPsw: '/login/icon-psw.png',
    loginIconRadio: '/login/icon-radio.png',
    loginIconRadioActive: '/login/icon-radio-active.png',
    loginIconClear: '/login/icon-clear.png',
    searchIconSH: '/search/sh.png',
    searchIconSZ: '/search/sz.png',
    searchIconCompany: '/search/company.png',
    searchIconHK: '/search/hk.png',
    searchIconUS: '/search/us.png',
    searchIconFund: '/search/fund.png',
    searchIconPlate: '/search/plate.png',
    searchIconFU: '/search/fu.png',
    indexQuoteRise: '/indexQuote/rise.png',
    indexQuoteFall: '/indexQuote/fall.png',
};

export const getPath = (key) => {
    return (pathMap[key] && `${basicPath}${pathMap[key]}`) || key;
};
